import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import PLUPageStore, { PLUCopyModeType } from 'stores/PLU/PLUPageStore';
import { CopyPLUFromWeekForm } from 'stores/Forms/PLU/CopyMode/CopyPLUFromWeekForm';
import { PLUPlannerTab } from 'stores/PLU/PLUPlannerStore';
import AppRouter from 'stores/AppRouter';
import { ROUTES } from 'routes/routes';

import Spinner from 'components/Spinner/Spinner';

import TabsControlled, {
  AppTabControlled,
} from 'components/Tabs/TabsControlled';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import PLUPlannerGrid from './PLUPlannerGrid';
import { CopyMode } from './CopyMenu/CopyMode';
import PLUPlannerCalendar from './PLUPlannerCalendar';

import style from './PLUPlanner.module.scss';

@observer
class PLUPlanner extends Component {
  private _store = new PLUPageStore();

  componentDidMount() {
    this._store.plannerStore.init();
  }

  private _tabs: AppTabControlled[] = [
    {
      title: 'title.settings.plu.tabs.spt',
      index: PLUPlannerTab.Spt,
    },
    {
      title: 'title.settings.plu.tabs.consumer',
      index: PLUPlannerTab.Consumer,
    },
  ];

  private _handleAddButtonClick() {
    AppRouter.push(ROUTES.admin.pluItemNew);
  }

  render() {
    const { plannerStore } = this._store;

    return (
      <main className={style.main}>
        {plannerStore.loading && <Spinner contain />}

        <TabsControlled
          tabs={this._tabs}
          activeTab={this._store.plannerStore.tab}
          onTabClick={this._store.plannerStore.changeTab}
        />

        <CopyMode store={this._store} />

        <div className={style.actions}>
          <Button className={style.btn} onClick={this._handleAddButtonClick}>
            <Icon type="cross" className={style.icon} />
            <FormattedMessage id="title.settings.plu.button.add" />
          </Button>
        </div>

        <div className={style.content}>
          <header className={style.header}>
            <div className={style.planner__title}>
              <div className={style.planner__week}>
                <FormattedMessage id="WEEK" />
                &nbsp;
                {plannerStore.weekNumber}
                {this._store.isCopyModeEnabled &&
                  this._store.copyModeType === PLUCopyModeType.Week &&
                  this._renderWeekSelectionMask()}
              </div>
            </div>

            <PLUPlannerCalendar store={plannerStore} />

            {plannerStore.isWeekDisabled && (
              <div className={style.warning}>
                <Icon type="info" className={style.icon__info} />
                <FormattedMessage id="warning.weekBlocked" />
              </div>
            )}
          </header>

          <div className={style.planner__footer__container}>
            <PLUPlannerGrid store={this._store} />
          </div>
        </div>
      </main>
    );
  }

  private _renderWeekSelectionMask = () => {
    const form = this._store.copyModeForm as CopyPLUFromWeekForm;

    return (
      <div
        className={classNames(style.selectionMask, style.selectionMaskWeek, {
          [style.active]:
            form.periodFrom[0].weekNumber ===
            this._store.plannerStore.weekNumber,
        })}
        onClick={() => form.setPeriodFrom(this._store.plannerStore.date)}
      />
    );
  };
}

export default PLUPlanner;
